import type {
  Process,
  ProcessGroup,
  TrendsPageFilterStateType,
} from "../../types/types";
import { TrendChartBinSizesEnum } from "../../types/enums";
import {
  isVariationOfAll,
  ALL_PNL_CATEGORY_NAME_DISPLAY,
} from "./TrendsFilters/filtersDrawerUtils";

export function getAllProcessesWithCurrentFilters(
  trendsPageFilterState: TrendsPageFilterStateType,
  processes: Process[],
  groups: ProcessGroup[],
  isTrendsPageFilteredByGroup: boolean,
  isTrendsPageFilteredByProcess: boolean
): Process[] {
  if (isTrendsPageFilteredByGroup) {
    return (
      groups.find(g => g.longName === trendsPageFilterState.group)?.processes ||
      []
    );
  }

  if (isTrendsPageFilteredByProcess) {
    return [trendsPageFilterState.process];
  }

  return processes.filter(
    process =>
      process.workScheduleConfig.id === trendsPageFilterState.workScheduleId
  );
}

export type ParsedTrendsPageFilterStateType = {
  isTrendsPageFilteredByTag: boolean;
  isTrendsPageFilteredByPnlCategory: boolean;
  isTrendsPageFilteredByShift: boolean;
  isTrendsPageFilteredByProcess: boolean;
  isTrendsPageFilteredByGroup: boolean;
  isFiltered: boolean;
  trendsPageFilterState: TrendsPageFilterStateType;
};
export const parseTrendsPageFilterState = ({
  trendsPageFilterState,
}: {
  trendsPageFilterState: TrendsPageFilterStateType;
}): ParsedTrendsPageFilterStateType => {
  const { tag, shiftName, pnlCategory, group, process } = trendsPageFilterState;
  const isTrendsPageFilteredByTag = !isVariationOfAll(tag);
  const isTrendsPageFilteredByPnlCategory =
    pnlCategory !== ALL_PNL_CATEGORY_NAME_DISPLAY;
  const isTrendsPageFilteredByShift = !isVariationOfAll(shiftName);
  const isTrendsPageFilteredByProcess = !isVariationOfAll(process.name);
  const isTrendsPageFilteredByGroup = !isVariationOfAll(group);

  const isFiltered =
    isTrendsPageFilteredByTag ||
    isTrendsPageFilteredByPnlCategory ||
    isTrendsPageFilteredByGroup ||
    isTrendsPageFilteredByProcess ||
    isTrendsPageFilteredByShift;
  return {
    isTrendsPageFilteredByTag,
    isTrendsPageFilteredByPnlCategory,
    isTrendsPageFilteredByShift,
    isTrendsPageFilteredByProcess,
    isTrendsPageFilteredByGroup,
    isFiltered,
    trendsPageFilterState,
  };
};

const { hours, days, weeks } = TrendChartBinSizesEnum;

export const TREND_CHART_ALLOWED_BIN_SIZES_BY_RANGE_MAP = {
  /** for a day or less, we can see hour bins */
  day: [hours],
  /** for a week or less, we can see hours / days */
  week: [days, hours],
  /** for a month or less, we can see weeks / days */
  month: [weeks, days],
  /** above that, same */
  ninetyDays: [weeks, days],
};
